/**
 * Reactivate Company
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';

import {
  ACTION_PUT_COMPANY_STATUS_FAILURE,
  ACTION_PUT_COMPANY_STATUS_SUCCESS,
  ACTION_REACTIVATE_COMPANY,
  ACTION_UPDATE_COMPANY_STATUS,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

export function reactivateCompany(companyId: string) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organization/${companyId}/reactivate`,
        method: 'put',
        data: JSON.stringify({}),
        success: (response: any) => {
          enqueueSnackbarHandler(
            dispatch,
            { reactivateCompanySuccess: true },
            'success',
          );
          dispatch(updateCompanyStatus(response));
          dispatch(requestSuccess(response));
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_STATUS_SUCCESS,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_STATUS_FAILURE,
    payload: responseJSON,
  };
}

function requestStarted() {
  return {
    type: ACTION_REACTIVATE_COMPANY,
    payload: null,
  };
}

function updateCompanyStatus(responseJSON: object) {
  return {
    type: ACTION_UPDATE_COMPANY_STATUS,
    payload: responseJSON,
  };
}
